<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Error -->
    <div class="error">
      <div class="error__content">
        <h2>{{ $t('noPermissions.noPermissionsTitle') }}</h2>
        <h3>{{ $t('noPermissions.noPermissionsText') }}</h3>
        <p>{{ $t('noPermissions.noPermissionsDescription') }}</p>
        <d-button pill @click="goBack">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.back') }}
        </d-button>
      </div>
    </div>
  </d-container>
</template>

<script>
export default {
  name: 'no-permissions',
  methods: {
    goBack() {
      window.history.go(-2);
    }
  }
}
</script>
